import { Component, Input, OnInit, SkipSelf } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';

@Component({
    selector: 'check',
    templateUrl: './check.component.html',
    styleUrls: ['./check.component.scss'],
    viewProviders: [
        {
            provide: ControlContainer,
            useFactory: (container: ControlContainer) => container,
            deps: [[new SkipSelf(), ControlContainer]],
        },
    ],
    standalone: false
})
export class CheckComponent implements OnInit {
  @Input() derrors = false;
  constructor(private controlContainer: FormGroupDirective) {}
  get form() {
    return this.controlContainer.form;
  }
  ngOnInit(): void {}
}
